import { AiOutlineWarning } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';

export const LogoMissingNotice = ({ companyId }) => {
  const history = useHistory();
  const destination = companyId ? `/company/details/${companyId}` : '/company';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 14px',
        marginBottom: 12,
        backgroundColor: '#fff8e1',
        border: '1px solid #f5d76e',
        borderRadius: 4,
        fontSize: 13,
        color: '#5d4a00',
      }}
    >
      <AiOutlineWarning size={18} style={{ flexShrink: 0 }} />
      <span style={{ flex: 1 }}>
        Sua empresa não tem logo cadastrada. Os PDFs serão impressos sem logo.
      </span>
      <button
        type="button"
        onClick={() => history.push(destination)}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          color: '#0d6efd',
          textDecoration: 'underline',
          cursor: 'pointer',
          fontSize: 13,
          fontWeight: 500,
          flexShrink: 0,
        }}
      >
        Cadastrar logo
      </button>
    </div>
  );
};
